import {
  apiPost,
  PostRetryIncomingConsultationRequest,
  PostRetryIncomingConsultationResponse,
} from 'api';

export const postRetryIncomingConsultation = (
  request: PostRetryIncomingConsultationRequest
): Promise<PostRetryIncomingConsultationResponse> =>
  apiPost<PostRetryIncomingConsultationResponse, PostRetryIncomingConsultationRequest>(
    `admin/publishevent`,
    request
  );
